import type { LocationMapSimpleProps } from "./location-map-simple.type";

import {
  MapInteractive,
  parseLatLngString,
  createMapMarker,
} from "@/modules/map";

const LocationMapSimple = ({ location, context }: LocationMapSimpleProps) => {
  const { coordinate } = location;

  const mapId = `${context}_${location?.id}`;
  const position = parseLatLngString({ coordinate });
  const marker = createMapMarker({
    key: mapId,
    position,
  });

  return (
    <MapInteractive
      id={mapId}
      markers={marker ? [marker] : []}
      sizes={{ ratio: "16:9" }}
      noInfoWindow
    />
  );
};

export default LocationMapSimple;
